import {
  Badge,
  Box,
  Card,
  HStack,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react"
import type { QuizPerformance } from "../../../client"

interface PerformanceByQuizChartProps {
  data: QuizPerformance[]
}

export default function PerformanceByQuizChart({
  data,
}: PerformanceByQuizChartProps) {
  if (data.length === 0) {
    return (
      <Card.Root h="full">
        <Card.Body>
          <Heading size="md" mb={4}>
            Performance by Quiz
          </Heading>
          <Text color="gray.500">No data available</Text>
        </Card.Body>
      </Card.Root>
    )
  }

  // Sort by performance (descending)
  const sortedData = [...data].sort(
    (a, b) => b.correct_percentage - a.correct_percentage,
  )

  const getColor = (percentage: number) => {
    if (percentage >= 70) return "green"
    if (percentage >= 40) return "yellow"
    return "red"
  }

  return (
    <Card.Root h="full">
      <Card.Body>
        <Heading size="md" mb={4}>
          Performance by Quiz
        </Heading>

        <VStack align="stretch" gap={3} mt={4}>
          {sortedData.map((quiz) => (
            <Box key={quiz.quiz_id}>
              <HStack justify="space-between" mb={1}>
                <HStack>
                  <Text fontSize="sm" fontWeight="medium" truncate maxW="200px">
                    {quiz.quiz_name}
                  </Text>
                  {quiz.is_practice && (
                    <Badge colorScheme="purple" size="sm">
                      Practice
                    </Badge>
                  )}
                </HStack>
                <Text
                  fontSize="sm"
                  fontWeight="bold"
                  color={`${getColor(quiz.correct_percentage)}.600`}
                >
                  {quiz.correct_percentage.toFixed(1)}%
                </Text>
              </HStack>
              <Box bg="gray.100" h="8px" borderRadius="full" overflow="hidden">
                <Box
                  bg={`${getColor(quiz.correct_percentage)}.400`}
                  h="full"
                  w={`${quiz.correct_percentage}%`}
                  transition="width 0.3s"
                />
              </Box>
            </Box>
          ))}
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
